import React, { useContext } from 'react';
import { AuthContext, IAuthContext } from 'src/state/providers/AuthProvider';
import { KatSpinner } from '@amzn/katal-react';
import {
  AMAZON_AUTH_DOMAINS,
  DEPLOYED_STAGE,
  GET_AMAZON_AUTH_SIGNOUT_URL,
  GET_AMAZON_AUTH_URL,
} from 'src/constants/UrlConstants';
import { logger } from 'src/logger';
import { useLocalizationContext } from '@amzn/react-arb-tools';

export const AuthUrlGeneration = {
  getDeployedStage(): string {
    return DEPLOYED_STAGE.toUpperCase();
  },

  getCurrentUrl(): string {
    return encodeURIComponent(window.location.href);
  },

  generateAuthUrl(language: string, redirectUrl?: string): string {
    const stage = this.getDeployedStage();
    const amazonDomain = AMAZON_AUTH_DOMAINS[stage];
    const redirectTo = redirectUrl || AuthUrlGeneration.getCurrentUrl();
    logger.info(`Redirect URL is: ${redirectTo}`);
    language = language.replace('-', '_'); //Amazon Auth uses locale as 'en_US' but Panther and Katal uses 'en-US'
    return GET_AMAZON_AUTH_URL(amazonDomain, redirectTo, language);
  },

  generateSignoutUrl(language: string, redirectUrl?: string): string {
    const stage = this.getDeployedStage();
    const amazonDomain = AMAZON_AUTH_DOMAINS[stage];
    const redirectTo = redirectUrl || AuthUrlGeneration.getCurrentUrl();
    logger.info(`Redirect URL is: ${redirectTo}`);
    language = language.replace('-', '_'); //Amazon Auth uses locale as 'en_US' but Panther and Katal uses 'en-US'
    return GET_AMAZON_AUTH_SIGNOUT_URL(amazonDomain, redirectTo, language);
  },
};

const AuthenticatedRoute = ({ children }) => {
  const authContext = useContext<IAuthContext>(AuthContext);
  const { localizationContext } = useLocalizationContext();
  if (!authContext.customerId) {
    logger.info('CustomerId is invalid. Redirecting to AuthPortal');
    const authUrl = AuthUrlGeneration.generateAuthUrl(
      localizationContext.getLocale(),
    );
    logger.info(`Generated AuthUrl is: ${authUrl}`);
    window.location.assign(authUrl);
    return <KatSpinner size="large"></KatSpinner>;
  }
  logger.info('User is authenticated. Skiping Re-Auth page');
  return <>{children}</>;
};

export { AuthenticatedRoute };
